(function () {
  const config = window.AnnouncementConfig;
  if (!config) return;

  // ─── UTM Helper ────────────────────────────────────────────────────────────
  function getUTMParam(key) {
    try {
      return new URLSearchParams(window.location.search).get(key);
    } catch (e) {
      var match = window.location.search.match(new RegExp('[?&]' + key + '=([^&]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
  }

  // ─── Cache DOM ─────────────────────────────────────────────────────────────
  const dom = {
    defaultBar:  document.querySelector('.without--utm_parameter'),
    dynamicBar:  document.querySelector('.js-dynamic-bar'),
    textPocket:  document.querySelector('.js-dynamic-bar-text-pocket span'),
    textLap:     document.querySelector('.js-dynamic-bar-text-lap span'),
  };

  // ─── Show dynamic announcement ─────────────────────────────────────────────
  function showAnnouncement(offer) {
    if (!offer || !dom.dynamicBar) return;
    dom.defaultBar?.style.setProperty('display', 'none');
    dom.dynamicBar.style.display = 'block';
    if (dom.textPocket) dom.textPocket.textContent = offer.text || '';
    if (dom.textLap)    dom.textLap.textContent    = offer.mobileText || offer.text || '';
  }

  // ─── Handle show/hide overrides ────────────────────────────────────────────
  function handleOverride(override) {
    if (!override) return;
    if (override.hideDefault) dom.defaultBar?.style.setProperty('display', 'none');
    if (override.showSelector) {
      const el = document.querySelector(override.showSelector);
      if (el) el.style.display = 'block';
    }
  }

  // ─── Init ──────────────────────────────────────────────────────────────────
  function init() {
    const utmContent  = getUTMParam('utm_content');
    const utmCampaign = getUTMParam('utm_campaign');

    // Pick the right announcements map based on page type
    const announcements = config.isProduct
      ? config.productAnnouncements
      : config.isCollection
        ? config.collectionAnnouncements
        : {};

    // 1. Match announcement (utm_content takes priority)
    const offerKey = utmCampaign;
    if (offerKey && announcements[offerKey]) {
      showAnnouncement(announcements[offerKey]);
      return;
    }

    // 2. Match campaign override (e.g. dailyradiancesampler, bloomingpouch)
    if (utmCampaign && config.campaignOverrides?.[utmCampaign]) {
      handleOverride(config.campaignOverrides[utmCampaign]);
      return;
    }

    // 3. Match content override (e.g. guthealthorg)
    if (utmContent && config.contentOverrides?.[utmContent]) {
      handleOverride(config.contentOverrides[utmContent]);
    }
  }

  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();